export default function isRunningInBrowser() {
  return ('undefined' !== typeof window);
}
